module.exports = __webpack_public_path__ + "img/delete.4bf205d9.svg";